/* tslint:disable */
import {
  App,
  Entity
} from '../index';

declare var Object: any;
export interface EntitylistlayoutInterface {
  name: string;
  label: string;
  status: string;
  picklistcustomvalues?: Array<any>;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  appId?: any;
  entityId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
  entity?: Entity;
}

export class Entitylistlayout implements EntitylistlayoutInterface {
  name: string;
  label: string;
  status: string;
  picklistcustomvalues: Array<any>;
  lastupdatedby: string;
  createdby: string;
  id: any;
  appId: any;
  entityId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  entity: Entity;
  constructor(data?: EntitylistlayoutInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Entitylistlayout`.
   */
  public static getModelName() {
    return "Entitylistlayout";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Entitylistlayout for dynamic purposes.
  **/
  public static factory(data: EntitylistlayoutInterface): Entitylistlayout{
    return new Entitylistlayout(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Entitylistlayout',
      plural: 'entitylistlayouts',
      properties: {
        name: {
          name: 'name',
          type: 'string'
        },
        label: {
          name: 'label',
          type: 'string'
        },
        status: {
          name: 'status',
          type: 'string'
        },
        picklistcustomvalues: {
          name: 'picklistcustomvalues',
          type: 'Array&lt;any&gt;'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        entityId: {
          name: 'entityId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
        entity: {
          name: 'entity',
          type: 'Entity',
          model: 'Entity'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Entitylistlayout.ts